import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=69072a58"
import script from "./Foot.vue?vue&type=script&lang=ts"
export * from "./Foot.vue?vue&type=script&lang=ts"
import style0 from "./Foot.vue?vue&type=style&index=0&id=69072a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports